export default "__VITE_ASSET__5cdc3cb5__"